<template>
  <div class="for-you__body">
    <div class="feedback">
      <transition name="fade" @enter="enterSuccessFeedback">
        <FeedbackSuccess
          v-if="showableSuccessFeedback"
          :message="successMessage"
        />
      </transition>
      <transition name="fade" @enter="enterErrorFeedback">
        <FeedbackError v-if="showableErrorFeedback" :message="errorMessage" />
      </transition>
    </div>
    <div v-if="loggedIn">
      <div v-if="isLoading" class="for-you__loading">
        <Loading />
      </div>
      <div
        v-else-if="isEmptyPersonalNotifications"
        class="for-you__empty__area"
      >
        <p class="for-you__empty__title">現在お知らせありません</p>
        <p class="for-you__empty__detail">
          ギフトやお礼メッセージの受信、
          <br />
          各種特典の利用リマインドなどが
          <br />
          こちらに通知されます
        </p>
      </div>
      <div v-else>
        <div class="for-you__personal-notification-header__area">
          <p class="for-you__personal-notification-header__message">
            直近30日以内のお知らせを表示しています
          </p>
          <a
            v-if="showReadAll"
            class="for-you__personal-notification-header__read-all-link"
            @click.prevent="onClickReadAll"
          >
            すべて既読にする
          </a>
        </div>
        <PersonalNotificationBoxes
          :personal-notifications="personalNotifications"
          @click-personal-notification-delete-button="onClickDeleteButton"
          @click-personal-notification-link="onClickLink"
        />
        <Pagination
          :current-page="currentPage"
          :total-pages="totalPages"
          @clicked="onClickPageLink"
        />
        <TextModal
          v-if="showDeleteModal"
          title-text="お知らせ一覧から削除"
          caption-text="選択したお知らせを
削除してもよろしいですか？"
          primary-button-text="削除する"
          cancel-button-text="キャンセル"
          :primary-button-disabled="deleteModalPerimaryButtonDisabled"
          @clicked-modal-cover="closeModal"
          @clicked-primary="onClickModalPerimaryButton"
          @clicked-cancel="closeModal"
        />
      </div>
    </div>
    <div v-else class="for-you__logged-out__area">
      <p class="for-you__logged-out__title">
        会員登録（無料）をしていただくと
        <br />
        ギフトやお礼メッセージなどに関する
        <br />
        新着情報をお知らせいたします
      </p>
      <img
        src="../../../../../images/personal-notification-sample.svg"
        class="for-you__logged-out__image"
      />
      <div class="for-you__logged-out__button-area">
        <ButtonPrimary
          text="新規会員登録する"
          @click-primary-button="onClickNewRegistration"
        />
        <ButtonSecondary
          text="ログインする"
          @click-secondary-button="onClickLogin"
        />
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import dayjs from 'dayjs'
import FeedbackSuccess from '../../atoms/feedbacks/feedback-success.vue'
import FeedbackError from '../../atoms/feedbacks/feedback-error.vue'
import Loading from '../../atoms/loadings/Loading.vue'
import Pagination from '../../organism/paginations/Pagination.vue'
import PersonalNotificationBoxes from '../../organism/notifications/personal_notification/PersonalNotificationBoxes.vue'
import ButtonPrimary from '../../molecules/buttons/ButtonPrimary.vue'
import ButtonSecondary from '../../molecules/buttons/ButtonSecondary.vue'
import TextModal from '../../molecules/modals/text-modal.vue'
import url from 'url'
import qs from 'qs'

export default {
  components: {
    FeedbackSuccess,
    FeedbackError,
    Loading,
    PersonalNotificationBoxes,
    Pagination,
    ButtonPrimary,
    ButtonSecondary,
    TextModal
  },
  props: {
    isActive: {
      type: Boolean,
      required: false,
      default: false
    },
    loggedIn: {
      type: Boolean,
      required: false,
      default: false
    },
    registrationPath: {
      type: String,
      required: false,
      default: ''
    },
    loginPath: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      personalNotifications: [],
      isLoading: false,
      showableSuccessFeedback: false,
      successMessage: '',
      showableErrorFeedback: false,
      errorMessage: '',
      currentPage: 1,
      totalPages: 1,
      showDeleteModal: false,
      deleteTargetId: '',
      deleteModalPerimaryButtonDisabled: false,
      showReadAll: false
    }
  },
  computed: {
    isEmptyPersonalNotifications() {
      return this.personalNotifications.length === 0
    },
    historyPath() {
      const pathname = url.parse(location.href).pathname
      const pageNumber = this.currentPage <= 1 ? 1 : this.currentPage
      return `${pathname}?page=${pageNumber}#for-you`
    }
  },
  mounted() {
    this.initializeParams()
    this.getPersonalNotifications(this.currentPage)
  },
  methods: {
    initializeParams() {
      const urlQueries = url.parse(location.href).query
      if (!this.isActive || !urlQueries) {
        this.currentPage = 1
        return
      }
      const parsed = qs.parse(urlQueries)
      this.currentPage = parsed.page ? Number(parsed.page) : 1
    },
    updateUrlFromParams() {
      history.pushState('', '', this.historyPath)
    },
    async getPersonalNotifications(page) {
      this.isLoading = true
      try {
        const res = await axios.get(
          `/api/v1/users/@me/notifications/personal_notifications?page=${
            page ? page : 1
          }`
        )
        if (res.data) {
          const { current_page, total_pages, has_for_you_unread } =
            res.data.meta
          this.currentPage = current_page
          this.totalPages = total_pages
          this.personalNotifications = res.data.data
            .map(personalNotifications => personalNotifications.attributes)
            .map(personalNotification => ({
              id: personalNotification.id,
              message: personalNotification.message,
              startedAt: dayjs(personalNotification.createdAt).format(
                'YYYY年M月D日 HH:mm'
              ),
              iconUrl: personalNotification.iconUrl,
              iconStyle: personalNotification.iconStyle,
              linkUrl: personalNotification.linkUrl,
              unread: personalNotification.unread
            }))
          this.showReadAll = has_for_you_unread

          // 1ページ目以外でデータが存在しないページの場合、1ページ目を表示させる
          if (page !== 1 && this.personalNotifications.length === 0) {
            await this.getPersonalNotifications(1)
            history.replaceState('', '', this.historyPath)
          }
          this.$emit(
            'personal-notification-loaded',
            has_for_you_unread,
            this.personalNotifications.length === 0
          )
        }
      } catch (error) {
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '情報の取得に失敗しました。しばらく経ってから再度アクセスしてください'
        this.showableErrorFeedback = true
      }
      this.isLoading = false
    },
    enterSuccessFeedback() {
      setTimeout(() => {
        this.showableSuccessFeedback = false
      }, 3000)
    },
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    async onClickPageLink(page) {
      this.scrollToTop()
      await this.getPersonalNotifications(page)
      this.updateUrlFromParams()
    },
    scrollToTop() {
      window.scrollTo({ top, behavior: 'smooth' })
    },
    onClickDeleteButton(personalNotificationId) {
      this.deleteTargetId = personalNotificationId
      this.showDeleteModal = true
    },
    closeModal() {
      this.deleteTargetId = ''
      this.deleteModalPerimaryButtonDisabled = false
      this.showDeleteModal = false
    },
    async onClickModalPerimaryButton() {
      this.deleteModalPerimaryButtonDisabled = true
      await this.delete(this.deleteTargetId)
      await this.getPersonalNotifications(this.currentPage)
      this.closeModal()
    },
    async delete(personalNotificationId) {
      try {
        await axios.delete('/api/v1/users/@me/notifications/delete', {
          data: { notification: { id: personalNotificationId } }
        })
      } catch (error) {
        // TODO: Rails 側でエラーが発生した際にフロント側でどのような処理をするかを検討し、ここに実装する
        if (
          !error.response ||
          !error.response.status ||
          !error.response.statusText
        ) {
          console.log(`Error :${error}`)
          return
        }
        const { status, statusText } = error.response
        console.log(`Error! HTTP Status: ${status} ${statusText}`)
        const errorMessage = error.response.data.message
        if (errorMessage) {
          console.log(`Error message: ${errorMessage}`)
        }
      }
    },
    async onClickLink(personalNotificationId) {
      await this.updateRead(personalNotificationId)
    },
    async onClickReadAll() {
      this.showReadAll = false
      await this.updateReadAll()
      this.personalNotifications.forEach(personalNotification => {
        personalNotification.unread = false
      })
      this.$emit('change-unread-in-for-you-tab', false)
    },
    async updateRead(personalNotificationId) {
      try {
        await axios.patch('/api/v1/users/@me/notifications/read', {
          notification: { id: personalNotificationId }
        })
      } catch (error) {
        // TODO: Rails 側でエラーが発生した際にフロント側でどのような処理をするかを検討し、ここに実装する
        if (
          !error.response ||
          !error.response.status ||
          !error.response.statusText
        ) {
          console.log(`Error :${error}`)
          return
        }
        const { status, statusText } = error.response
        console.log(`Error! HTTP Status: ${status} ${statusText}`)
        const errorMessage = error.response.data.message
        if (errorMessage) {
          console.log(`Error message: ${errorMessage}`)
        }
      }
    },
    async updateReadAll() {
      try {
        await axios.patch('/api/v1/users/@me/notifications/read_all')

        this.successMessage = 'すべてのお知らせを既読にしました'
        this.showableSuccessFeedback = true
      } catch (error) {
        // TODO: Rails 側でエラーが発生した際にフロント側でどのような処理をするかを検討し、ここに実装する
        if (
          !error.response ||
          !error.response.status ||
          !error.response.statusText
        ) {
          console.log(`Error :${error}`)
          return
        }
        const { status, statusText } = error.response
        console.log(`Error! HTTP Status: ${status} ${statusText}`)
        const errorMessage = error.response.data.message
        if (errorMessage) {
          console.log(`Error message: ${errorMessage}`)
        }
      }
    },
    onClickNewRegistration() {
      dataLayer.push({
        event: 'signup_click',
        button: 'notifications'
      })
      window.location.href = this.registrationPath
    },
    onClickLogin() {
      dataLayer.push({
        event: 'signin_click',
        button: 'notifications'
      })
      window.location.href = this.loginPath
    }
  }
}
</script>
<style lang="scss" scoped>
.for-you {
  overflow: hidden;

  &__loading {
    padding: 24px;
  }

  &__empty {
    &__area {
      padding: 28px 0 44px;
    }

    &__title {
      @extend %body-bold;
      color: $gray-1;
      margin-bottom: 8px;
    }

    &__detail {
      @extend %body;
      color: $gray-1;
      line-height: 1.6;
    }
  }

  &__body {
    background-color: $white;
    padding-top: 24px;
  }

  &__personal-notification-header {
    &__area {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto 16px auto;
      padding: 0 16px;
    }

    &__message {
      @extend %minimal;
    }

    &__read-all-link {
      @extend %caption;
      color: $link;
      cursor: pointer;
    }
  }

  &__logged-out {
    &__area {
      max-width: 375px;
      margin: auto;
      padding: 16px 16px 40px;
    }

    &__title {
      @extend %subhead-bold;
    }

    &__image {
      margin-top: 24px;
      width: 304px;
      height: 158px;
      border: solid 6px $gray-3;
      border-radius: 8px;
    }

    &__button-area {
      margin: 32px auto 0 auto;
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }
}
</style>
